const normalizeToolFunctionName = name => {
  const value = String(name || '')
  const slash = value.split('/').filter(Boolean).pop() || value
  return slash.split('.').filter(Boolean).pop() || slash
}

const isAsyncContinuationCall = toolCall => {
  const name = normalizeToolFunctionName(toolCall && toolCall.function && toolCall.function.name)
  return name === 'poll_tool_output' || name === 'write_stdin'
}

const toolCallForRendering = toolCall => {
  const fn = toolCall && toolCall.function
  if (!toolCall || !toolCall.id || !fn || typeof fn.name !== 'string' || !fn.name) return null
  return {
    ...toolCall,
    function: {
      ...fn,
      arguments: typeof fn.arguments === 'string' ? fn.arguments : ''
    }
  }
}

const firstToolCallForRendering = toolCalls => {
  if (!Array.isArray(toolCalls)) return null
  for (const toolCall of toolCalls) {
    const renderable = toolCallForRendering(toolCall)
    if (renderable) return renderable
  }
  return null
}

const directEvents = value => {
  const events = Array.isArray(value) ? value : value ? [value] : []
  return events.filter(event => event && event.id && event.message)
}

const transcriptEntriesWithInferenceProgress = directEvents

const assistantTranscriptRenderUnits = value => {
  const events = directEvents(value)
  return events.length ? [events] : []
}

const parseResult = content => {
  try {
    return JSON.parse(String(content || ''))
  } catch (err) {
    return null
  }
}

const resultSessionId = content => {
  const result = parseResult(content)
  const nested = result && result.output && typeof result.output === 'object' ? result.output : null
  return result && (result.session_id || result.sessionId) ||
    nested && (nested.session_id || nested.sessionId) || null
}

const toolResultRenderUnit = (value, toolCallId, exactContent) => {
  const events = directEvents(value)
  const calls = new Map()
  for (const event of events) {
    for (const call of event.message.tool_calls || []) {
      const renderable = toolCallForRendering(call)
      if (renderable) calls.set(renderable.id, renderable)
    }
  }
  let renderToolCallId = toolCallId
  const targetCall = calls.get(toolCallId)
  if (isAsyncContinuationCall(targetCall)) {
    const sessionId = resultSessionId(exactContent)
    if (sessionId) {
      for (const event of events) {
        const message = event.message
        if (!message.tool_call_id || !message.content) continue
        if (resultSessionId(message.content) !== sessionId) continue
        if (!isAsyncContinuationCall(calls.get(message.tool_call_id))) {
          renderToolCallId = message.tool_call_id
          break
        }
      }
    }
  }
  return events.some(event => event.message.tool_call_id === renderToolCallId)
    ? events
    : null
}

module.exports = {
  assistantTranscriptRenderUnits,
  firstToolCallForRendering,
  transcriptEntriesWithInferenceProgress,
  toolCallForRendering,
  toolResultRenderUnit,
  isAsyncContinuationCall,
  normalizeToolFunctionName
}
